// extracted by mini-css-extract-plugin
export default {"wrapper":"Owner_wrapper__+SNuI","title":"Owner_title__nLMLC","description":"Owner_description__is2rA","chart_owner":"Owner_chart_owner__rdOOe"};